import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { DailyCheckInSet } from '@core/models/daily-check-in.model';

/** Daily Check-In reward sets — AIO-80387. */
@Injectable()
export class DailyCheckInEntityService extends EntityCollectionServiceBase<DailyCheckInSet> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('DailyCheckInSet', serviceElementsFactory);
  }
}
